module.exports = __webpack_public_path__ + "img/aqc.01d55b5f.jpg";